import { animation, state, trigger, animateChild, group, transition, animate, style, query } from '@angular/animations';
export const exportAnimation = trigger('exportAnimations', [
	state(
		'changing',
		style({
			position: 'absolute',
			top: '16px',
			width: '960px',
			height: '160px',
			left: '50%',
			marginLeft: '-480px'
		})
	),
	state(
		'changed',
		style({
			position: 'relative',
			width: '560px',
			height: '100px',
			margin: 'auto',
			paddingTop: '16px',
			borderRadius: '4px',
			opacity: 0.5,
			display: 'none'
		})
	),
	state(
		'changing_',
		style({
			position: 'absolute !important',
			top: '192px !important',
			bottom: '56px',
			width: '960px',
			height: 'auto !important',
			overflow: 'auto',
			left: '50%',
			marginLeft: '-480px'
		})
	),
	state(
		'changed_',
		style({
			position: 'relative',
			width: '560px',
			height: '100px',
			margin: 'auto',
			paddingTop: '16px',
			borderRadius: '4px',
			opacity: 0.5,
			display: 'none'
		})
	),
	transition('*=>*', [animate('0.2s')])
]);
